export default {
  camelCaseToUnderscore(stringInput: string) {
    return stringInput.replace(/\.?([A-Z])/g, (_x, y) => `_${y.toLowerCase()}`);
  },

  underscoreToCamelCase(stringInput: string) {
    return stringInput.replace(/_([a-z])/g, g => g[1].toUpperCase());
  },
};
